module.exports = __webpack_public_path__ + "9f4964b838391e25ad2a72b3275d513e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/frilly-flower-purple-s.png
// module id = 2200
// module chunks = 0